import axios from "axios";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import login from "./login.css";
import Upload from "../../Hooks/Upload";
import kenya from "./../../kenya.png";

const api = axios.create({
  baseURL: "https://ntsp.tourkenya.go.ke",
  headers: {
    "Content-Type": "application/json",
    Accept: "*/*",
  },
});

const SelfRegistration = () => {
  const [inputs, setInputs] = useState({
    name: "",
    email: "",
    mobile: "",
    password: "",
  });

  const [disabled, setDisabled] = useState(false);
  const [userType, setUserType] = useState("PUBLIC_USER");

  const handleFileChange = (event) => {
    //for multiple files
    var files = event.target.files;

    onClickHandler(event, files);
  };
  const onClickHandler = (event, selectedFile) => {
    event.preventDefault();
    if (selectedFile) {
      const data = new FormData();
      for (var x = 0; x < selectedFile.length; x++) {
        data.append("file", selectedFile[x]);
      }
      Upload.post("/api/upload/files", data, {
        onUploadProgress: (ProgressEvent) => {
          // setloaded((ProgressEvent.loaded / ProgressEvent.total) * 100);
        },
      })
        .then((res) => {
          if (res.status == "200" && res.data.resultCode == "00") {
            //setmessage("Certificate uploaded successfully");
            setInputs((inputs) => ({
              ...inputs,
              ["certificate"]: res.data.data,
            }));
            swal("", "Certificate uploaded", "success");
          } else {
            // setmessage("upload fail");
          }
        })
        .catch((err) => {
          // setmessage("upload fail");
        });
    } else {
      // setmessage("Select a file to upload");
    }
  };

  const handleInputChange = (e) => {
    setInputs({
      ...inputs,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisabled(true);
    let body = {
      name: inputs.name ? inputs.name : inputs.establishmentName,
      email: inputs.email,
      mobile: inputs.mobile,
      password: inputs.password,
      securityGroupId: "10",
      category: "Applicant",
      userType: userType,
      certificate: inputs.certificate,
      registrationNo: inputs.registrationNo,
      establishmentName: inputs.establishmentName,
    };
    api.post("/api/registration", body).then(
      (response) => {
        setDisabled(false);

        swal("", "Registration completed successfully", "success").then(() => {
          window.location = "#/login";
        });
      },
      (error) => {
        setDisabled(false);

        swal("", "Failed to register account", "error");
      },
    );
  };

  // Input wrapper component with icon
  const InputWithIcon = ({
    icon,
    type,
    name,
    placeholder,
    value,
    onChange,
    required,
  }) => (
    <div className="position-relative">
      <span className="position-absolute start-0 top-50 translate-middle-y ms-3">
        {icon}
      </span>
      <input
        type={type}
        className="form-control"
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        style={{ paddingLeft: "45px" }}
      />
    </div>
  );

  return (
    <div className="container-fluid min-vh-100 p-0">
      <div className="row g-0 min-vh-100">
        <div
          className="col-md-6 rounded-0 d-none d-md-flex flex-column justify-content-center text-white p-5"
          style={{ background: "#0d5a43", overflow: "hidden" }}
        >
          <div style={{ maxWidth: "500px", margin: "0 auto" }}>
            {/* LOGO */}

            <img src={kenya} alt="NTSP" style={{ width: "400px" }} />

            <br />
            <br />
            <p
              className="text-light text-left"
              style={{ fontSize: "18px", lineHeight: "1.8" }}
            >
              Empowering Kenya's tourism sector through efficient,unified and
              secure digital services
            </p>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div
          className="col-md-6 d-flex justify-content-center align-items-center bg-light"
          style={{ padding: "40px 15px" }}
        >
          <div
            className="p-4 w-100"
            style={{ maxWidth: "80%", padding: "30px" }}
          >
            <h2 className="fw-bold mb-1 flex">Create an account</h2>
            <h2
              className="align-left fw-bold mb-1"
              style={{
                fontSize: "15px",
                textAlign: "left",
              }}
            >
              Register to access the NTSP portal.
            </h2>
            {/* TABS WITH ICONS */}
            <div className="row g-2 mt-3 mb-3">
              <div className="col-6">
                <button
                  type="btn-success"
                  onClick={() => setUserType("PUBLIC_USER")}
                  className={`btn w-100 d-flex align-items-center justify-content-center gap-2 ${
                    userType === "PUBLIC_USER"
                      ? "btn-success"
                      : "btn-outline-success"
                  }`}
                  style={{ gap: "8px" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                  Public User
                </button>
              </div>

              <div className="col-6">
                <button
                  type="button"
                  onClick={() => setUserType("ESTABLISHMENT")}
                  className={`btn w-100 d-flex align-items-center justify-content-center gap-2 ${
                    userType === "ESTABLISHMENT"
                      ? "btn-success"
                      : "btn-outline-success"
                  }`}
                  style={{ gap: "8px" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
                  </svg>
                  Establishment
                </button>
              </div>
            </div>
            {/* INFO BOX WITH ICON */}
            <div
              className="rounded-3 p-4 mb-4 d-flex align-items-center"
              style={{
                background: "#f3f6ff00",
                border: "1px solid #789beb",
                fontSize: "13px",
                color: "#789beb",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#789beb"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ marginRight: "10px", flexShrink: 0 }}
              >
                <path d="M12 2a10 10 0 0 0-10 10c0 4.2 2.6 7.8 6.3 9.3.5.2.7-.1.7-.4v-1.6c-2.6.6-3.2-1.1-3.2-1.1-.4-1.1-1-1.4-1-1.4-.8-.6 0-.6 0-.6.9.1 1.4.9 1.4.9.8 1.4 2.1 1 2.6.8.1-.6.3-1 .5-1.2-2-.2-4.1-1-4.1-4.4 0-1 .3-1.8.9-2.4-.1-.2-.4-1.1.1-2.3 0 0 .7-.2 2.4.9a8.3 8.3 0 0 1 4.4 0c1.7-1.1 2.4-.9 2.4-.9.5 1.2.2 2.1.1 2.3.6.6.9 1.4.9 2.4 0 3.4-2.1 4.2-4.1 4.4.3.3.6.8.6 1.6v2.4c0 .3.2.6.7.4 3.7-1.5 6.3-5.1 6.3-9.3 0-5.5-4.5-10-10-10z" />
              </svg>
              <span>
                Use this account type to apply for and track work permits for
                your organization.
              </span>
            </div>

            <form onSubmit={handleSubmit}>
              {/* ESTABLISHMENT */}
              {userType === "ESTABLISHMENT" && (
                <>
                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      Organization Name
                    </label>
                    <div className="position-relative">
                      <span className="position-absolute icon-position start-0 top-50 translate-middle-y ms-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#6c757d"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <rect
                            x="2"
                            y="7"
                            width="20"
                            height="14"
                            rx="2"
                            ry="2"
                          />
                          <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
                        </svg>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        name="establishmentName"
                        value={inputs.establishmentName}
                        onChange={handleInputChange}
                        placeholder="e.g. Safari Resorts Ltd"
                        required
                        style={{ paddingLeft: "45px" }}
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      Registration Number
                    </label>
                    <div className="position-relative">
                      <span className="position-absolute icon-position start-0 top-50 translate-middle-y ms-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#6c757d"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                          <polyline points="14 2 14 8 20 8" />
                          <line x1="16" y1="13" x2="8" y2="13" />
                          <line x1="16" y1="17" x2="8" y2="17" />
                          <polyline points="10 9 9 9 8 9" />
                        </svg>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        name="registrationNo"
                        value={inputs.registrationNo}
                        onChange={handleInputChange}
                        placeholder="e.g. REG/2026/001"
                        required
                        style={{ paddingLeft: "45px" }}
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-semibold">
                      Tourism License / Certificate
                    </label>

                    <label
                      className="w-100 text-center p-4 rounded-3"
                      style={{
                        border: "2px dashed #d7d7d7",
                        cursor: "pointer",
                        background: "#fafafa",
                      }}
                    >
                      <input
                        type="file"
                        hidden
                        name="certificate"
                        accept=".pdf,.jpg,.jpeg,.png"
                        onChange={handleFileChange}
                      />
                      <div className="fw-bold text-green ">
                        Click to upload document
                      </div>
                      <small className="text-muted">
                        PDF, JPG, PNG (Max 5MB)
                      </small>
                      <br></br>
                      <small style={{ color: "green" }}>
                        {inputs.certificate}
                      </small>
                    </label>
                  </div>
                </>
              )}

              {/* PUBLIC USER */}
              {userType === "PUBLIC_USER" && (
                <div className="mb-3">
                  <label className="form-label fw-semibold">Full Name</label>
                  <div className="position-relative">
                    <span className="position-absolute start-0 icon-position top-50 translate-middle-y ms-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#6c757d"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                      </svg>
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={inputs.name}
                      onChange={handleInputChange}
                      placeholder="Enter full name"
                      required
                      style={{ paddingLeft: "45px" }}
                    />
                  </div>
                </div>
              )}

              <div className="mb-3">
                <label className="form-label fw-semibold">Phone number</label>
                <div className="position-relative">
                  <span className="position-absolute start-0 icon-position top-50 translate-middle-y ms-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#6c757d"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
                      <line x1="12" y1="18" x2="12.01" y2="18" />
                    </svg>
                  </span>
                  <input
                    type="number"
                    className="form-control"
                    name="mobile"
                    placeholder="0712 345 678"
                    value={inputs.mobile}
                    onChange={handleInputChange}
                    required
                    style={{ paddingLeft: "45px" }}
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">Email Address</label>
                <div className="position-relative">
                  <span className="position-absolute start-0 icon-position top-50 translate-middle-y ms-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#6c757d"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                  </span>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={inputs.email}
                    onChange={handleInputChange}
                    placeholder="you@example.com"
                    required
                    style={{ paddingLeft: "45px" }}
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">Password</label>
                <div className="position-relative">
                  <span className="position-absolute icon-position start-0 top-50 translate-middle-y ms-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#6c757d"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                    </svg>
                  </span>
                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    value={inputs.password}
                    onChange={handleInputChange}
                    placeholder="********"
                    required
                    style={{ paddingLeft: "45px" }}
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="form-label fw-semibold">
                  Confirm Password
                </label>
                <div className="position-relative">
                  <span className="position-absolute icon-position start-0 top-50 translate-middle-y ms-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#6c757d"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                      <circle cx="12" cy="16" r="1" />
                    </svg>
                  </span>
                  <input
                    type="password"
                    className="form-control"
                    name="confirmPassword"
                    value={inputs.confirmPassword}
                    onChange={handleInputChange}
                    placeholder="********"
                    required
                    style={{ paddingLeft: "45px" }}
                  />
                </div>
              </div>

              <button
                type="submit"
                className="btn btn-success w-100 py-2 fw-bold rounded-3"
                disabled={disabled}
              >
                Create Account
              </button>

              <div className="text-center mt-3 pb-10">
                <p className="text-muted">
                  Already have an account?{" "}
                  <Link to="/login" className="text-success fw-bold">
                    Sign in
                  </Link>
                </p>
                <hr className=" my-4" />

                <p className="text-center text-muted mb-0">
                  &copy; 2026 Ministry of Tourism & Wildlife
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelfRegistration;
